export default {
  isMobile: null,
  smoothScroll: null,
  menu: null,
  observer: null
}
